import { OnPremHostnameDictionary } from '../interfaces/OnPremHostnameDictionary';
import OnPremHostnameConfiguration from './OnPremHostnameConfiguration';
import { getLanguage } from './getLanguage';

export function getHostName(): string {
  const configuredHostnames: OnPremHostnameDictionary = OnPremHostnameConfiguration();
  const contextKey = `${process.env.REACT_APP_CMS_USER_CONTEXT}_${process.env.REACT_APP_CMS_BUSINESS_ENTITY_CODE}`;

  if (contextKey in configuredHostnames) {
    if (typeof (configuredHostnames[contextKey]) === 'string') {
      return configuredHostnames[contextKey] as string;
    }

    const language = getLanguage();
    const configuredHostnamesByLanguage = configuredHostnames[contextKey] as OnPremHostnameDictionary;
    if (configuredHostnamesByLanguage && configuredHostnamesByLanguage[language]) {
      return configuredHostnamesByLanguage[language] as string;
    }
  }

  return '';
}
